// extracted by mini-css-extract-plugin
module.exports = {"contentComponent":"ProductTagsList_contentComponent__2nLHU","tableContainer":"ProductTagsList_tableContainer__1t1D8"};